

document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.querySelector('#search-input');
    var searchButton = document.querySelector('#search-button'); 
    var loadMoreButton = document.querySelector('.js-load-more');
    var isSearching = false; 
    var isRunning = false;
    // Hàm xử lý tìm kiếm
    function performSearch(query) {
        var xhr = new XMLHttpRequest();

      console.log('query='+encodeURIComponent(query))
        var url = '/search?q=' + encodeURIComponent(query) + '&type=article'; 
        xhr.open('GET', url + '&view=ajax_search', true);

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(xhr.responseText, 'text/html');
    
                    var searchResultsArticle = doc.querySelector('.search_results-article');
                    if (searchResultsArticle) {
                        var blogContainer = document.querySelector('.main-blog .blog-articles');
                        if (blogContainer) {
                            blogContainer.innerHTML = searchResultsArticle.innerHTML; 
                        }
                    }
                  
                    var searchResultsButton = doc.querySelector('.search_results-button');
                    if (searchResultsButton) {
                      var paginationContainer = document.querySelector('.blog-articles__pagination');
                      if (paginationContainer) {
                        paginationContainer.innerHTML = searchResultsButton.innerHTML;
                      } 
                    }
    
                    // Cập nhật URL trong data-next-link cho việc load more tiếp theo
                    var nextLink = doc.querySelector('[data-next-link]');
                    if (nextLink) {
                        document.querySelector('[data-next-link]').value = nextLink.value;
                        isSearching = true;
                    }
    
                    var mainBlog = document.querySelector('.main-blog');
                    if (mainBlog) {
                        mainBlog.scrollIntoView({ behavior: 'smooth' });
                    }
    
                    loadMoreButton = document.querySelector('.js-load-more');
                    if (loadMoreButton) {
                        loadMoreButton.addEventListener('click', function() {
                            loadMoreContent(); 
                        });
                    }
                } else {
                    console.log('Request failed. Returned status of ' + xhr.status);
                }
            }
        };

        xhr.send();
    }

    // Hàm xử lý load more
    function loadMoreContent() {
        var totalPages = parseInt(document.querySelector('[data-all-pages]').value, 10);
        var currentPage = parseInt(document.querySelector('[data-this-page]').value, 10);
        var nextUrl = document.querySelector('[data-next-link]').value;
        var current_page_new = currentPage + 1;
        var xhr = new XMLHttpRequest();

        if (isSearching) {
            xhr.open('GET', nextUrl, true);
        } else {
            var datacollurl = document.querySelector('[data-coll-url]').value;
            var next_coll = currentPage + 1;
            xhr.open('GET', datacollurl + "?page=" + next_coll, true);
        }

        loadMoreButton.setAttribute('disabled', true); 
        loadMoreButton.querySelector('.load-more_text').style.display = 'none'; 
        loadMoreButton.querySelector('.load-more_spinner').style.display = 'block'; 

        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(xhr.responseText, 'text/html');

                if (isSearching) {
                    var newArticles = doc.querySelector('.search_results-article');
                    if (newArticles) {
                        // document.querySelector('.blog-articles').innerHTML += newArticles.innerHTML; 
                        document.querySelector('.blog-articles').insertAdjacentHTML('beforeend', newArticles.innerHTML); 
                    }
                } else {
                    var newArticles = doc.querySelector('.blog-articles');
                    if (newArticles) {
                        // document.querySelector('.blog-articles').innerHTML += newArticles.innerHTML;
                        document.querySelector('.blog-articles').insertAdjacentHTML('beforeend', newArticles.innerHTML); 
                    }
                }

                var nextLink = doc.querySelector('[data-next-link]');
                if (nextLink) {
                    document.querySelector('[data-next-link]').value = nextLink.value;
                }
                document.querySelector('[data-this-page]').value = current_page_new;

                if (current_page_new < totalPages) {
                    loadMoreButton.removeAttribute('disabled');
                    loadMoreButton.querySelector('.load-more_text').style.display = 'block';
                    loadMoreButton.querySelector('.load-more_spinner').style.display = 'none';
                } else {
                    loadMoreButton.style.display = 'none';
                }
            }
        };

        xhr.send();
    }

    searchInput.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            var query = searchInput.value.trim();
            if (query) {
                performSearch(query);  
            } 
        }
    });

    searchButton.addEventListener('click', function(event) {
          event.preventDefault();
          var query = searchInput.value.trim();
          if (query) {
              performSearch(query);
          }
    });

    loadMoreButton.addEventListener('click', function() {
        loadMoreContent();
    });
});
